import { Box } from 'new/elements/Box';
import { Stack } from 'new/elements/Stack';
import React, { PropsWithChildren } from 'react';

interface TipBoxProps {
  className?: string;
}

export const TipBox = (props: PropsWithChildren<TipBoxProps>) => {
  const { children } = props;
  return (
    <Box className={props.className}>
      <Stack direction="row" padding="16px" gap="16px" alignItems="center">
        {children}
      </Stack>
    </Box>
  );
};
